/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_No_PhoneInputs */

const vi_grower_area_qr_no_phone = /** @type {(inputs: Grower_Area_Qr_No_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ này chưa có số điện thoại nên chưa tạo được mã QR vùng trồng. Vui lòng bổ sung số điện thoại của hộ.`)
};

/**

* @param {Grower_Area_Qr_No_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_no_phone = /** @type {((inputs?: Grower_Area_Qr_No_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_No_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_no_phone(inputs)
});